import type { LoaderFunctionArgs } from "react-router";

import { topasAggregatesClient } from "~/features/integration/topas-aggregates/client.server";
import { fetchJson } from "~/utils/fetch-json";

import { useQuery } from "@tanstack/react-query";
import { toMilliseconds } from "duration-fns";
import type { Jsonify } from "type-fest";

export type EventsData = Jsonify<Awaited<ReturnType<typeof loader>>>;

export const loader = async ({ context }: LoaderFunctionArgs) => {
  const client = topasAggregatesClient(context);
  const user = context.session?.user;

  const shouldIncludeSensitiveEvents =
    user?.rbac.isConductor || user?.rbac.isDriver || user?.rbac.isDeveloper;

  const response = await client.getAllOperationalInformationEventAggregates({
    includeSensitiveEvents: shouldIncludeSensitiveEvents,
  });

  return response;
};

export const EVENTS_QUERY_KEY = ["events"] as const;

export const eventsQueryFn = () => fetchJson<EventsData>("/api/events");

export const useEvents = () => {
  return useQuery({
    queryKey: EVENTS_QUERY_KEY,
    queryFn: eventsQueryFn,
    staleTime: toMilliseconds({ seconds: 10 }),
    refetchInterval: toMilliseconds({ seconds: 30 }),
    refetchIntervalInBackground: true,
    refetchOnReconnect: true,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });
};
